import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./viewBuilder.css";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  changeBuilderStatus,
  viewBuilder,
} from "../../Redux/Actions/builderActions";
import { Table } from "antd";
import { useSelector } from "react-redux";
import { getProjectList } from "../../Redux/Actions/projectActions";
import { getEventList } from "../../Redux/Actions/eventActions";
import { viewPropertyList } from "../../Redux/Actions/propertyActions";
import toast from "react-hot-toast";
import { getBookingsList } from "../../Redux/Actions/bookingActions";
import {
  columnsBookings,
  columnsDeals,
} from "../../Global Functions/columnsAntd";
import { viewDealsList } from "../../Redux/Actions/dealsAction";
import SelectInput from "../../Global Functions/selectInput";
import { columnsProjects } from "../../Global Functions/columnsAntd";
import { columnsProperties } from "../../Global Functions/columnsAntd";
import { columnsEvents } from "../../Global Functions/columnsAntd";
import { ToFirstCapital } from "../../Utils/helpers";
import { icons } from "../../icons";
import { viewTeamMembersList } from "../../Redux/Actions/teamMembersAction";
import axios from "axios";

const ViewBuilder = () => {
  const { id } = useParams();

  // const [blockPopup, setBlockPopup] = useState(false);

  // const handleBlockTrigger = () => {
  //   setBlockPopup(!blockPopup);
  // };

  const dispatch = useDispatch();

  const [selectedStatus, setSelectedStatus] = useState({
    id: id,
    account_status: "",
  });

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [selectedTable, setSelectedTable] = useState("projects");

  const handleTableSelection = (table) => {
    setSelectedTable(table);
  };

  const { builder } = useSelector((state) => state.builders || {});
  const { enumsData } = useSelector((state) => state.enumsData || {});
  const { projects } = useSelector((state) => state.projects || {});
  const { properties } = useSelector((state) => state.properties || {});
  const { events } = useSelector((state) => state.events || {});
  const { bookings } = useSelector((state) => state.bookings || {});
  const { deals } = useSelector((state) => state.deals || {});

  useEffect(() => {
    switch (selectedTable) {
      case "projects": {
        if (enumsData?.data?.ProjectStatus) {
          const statusEnums = Object.values(enumsData.data.ProjectStatus);
          if (statusEnums.length > 0) {
            const projectData = {
              status: statusEnums,
              page: 1,
              limit: 100,
              is_deleted: false,
              builder_id: id,
            };
            dispatch(getProjectList(projectData));
          }
        }
        break;
      }
      case "properties": {
        if (enumsData?.data?.PropertyStatus) {
          const statusEnums = Object.values(enumsData.data.PropertyStatus);
          if (statusEnums.length > 0) {
            const propertyData = {
              status: statusEnums,
              page: 1,
              limit: 100,
              is_deleted: false,
              builder_id: id,
            };
            dispatch(viewPropertyList(propertyData));
          }
        }
        break;
      }
      case "events": {
        if (enumsData?.data?.PropertyStatus) {
          const eventData = {
            page: 1,
            limit: 100,
            is_deleted: false,
            builder_id: id,
          };
          dispatch(getEventList(eventData));
        }
        break;
      }
      case "bookings": {
        const bookingData = {
          page: 1,
          limit: 1000,
          is_deleted: false,
          builder_id: id,
        };
        dispatch(getBookingsList(bookingData));

        break;
      }
      case "deals": {
        const dealsData = {
          page: 1,
          limit: 1000,
          is_deleted: false,
          builder_id: id,
        };
        dispatch(viewDealsList(dealsData));

        break;
      }
      default:
        break;
    }
  }, [enumsData, dispatch, id, selectedTable]);

  const [builderData, setBuilderData] = useState({});

  useEffect(() => {
    setBuilderData(builder?.data);
  }, [builder, id]);

  useEffect(() => {
    dispatch(viewBuilder(id));
  }, [dispatch, id]);

  const [personAssigned, setPersonAssigned] = useState({
    builder_id: id,
    persons: [],
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const fetchDetails = (page, pageSize, role) => {
    const teamData = {
      page,
      limit: pageSize,
      is_deleted: false,
      role: role,
    };
    dispatch(viewTeamMembersList(teamData));
  };
  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
  }, [dispatch]);

  const { teamMembers } = useSelector((state) => state.teamMembers);
  const handleStatusChange = (event) => {
    const statusUpdated = event.target.value;
    setSelectedStatus((prevData) => ({
      ...prevData,
      account_status: statusUpdated,
    }));
  };

  useEffect(() => {
    if (selectedStatus.account_status) {
      const updateStatus = async () => {
        try {
          const response = await dispatch(changeBuilderStatus(selectedStatus));

          if (response.statusCode === 200) {
            dispatch(viewBuilder(id));
          } else {
            toast.error(response?.message || "Something went wrong");
          }
        } catch (error) {
          toast.error(error?.message || "An error occurred");
        }
      };

      updateStatus();
    }
  }, [selectedStatus, dispatch, id]);

  const accountStatusData = enumsData?.data?.AccountStatus || {};
  const staffOptions = teamMembers?.data
    ? teamMembers.data.map((staff) => ({
      label: staff.name,
      value: staff._id,
    }))
    : [];

  const [memberAssigend, setmemberAssigend] = useState("");
  const handlePersonAssign = async (event) => {
    try {
      const selectedPersonId = event.target.value;
      setmemberAssigend(
        teamMembers?.data?.filter((u) => u._id === selectedPersonId)
      );
      if (!selectedPersonId) return;
      setPersonAssigned((prevData) => {
        const updatedPersons = prevData.persons.includes(selectedPersonId)
          ? prevData.persons
          : [...prevData.persons, selectedPersonId];
        const updatedPayload = {
          ...prevData,
          persons: updatedPersons,
        };
        axios.post(`${BASE_URL}/builder/assigned-person`, updatedPayload, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        return updatedPayload;
      });
    } catch (error) {
      console.error("Error in the try-catch block", error.message);
    }
  };

  return (
    <div className="overall_container_builder padding-20" style={{ background: "rgb(245, 247, 250)" }}>
      <div className="search_bar">
        <SearchBar />
      </div>
      <div
        style={{
          display: "flex",
          gridRow: "1 / 7",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <Link to="/builders">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h1>Builders Details</h1>
          <h4 className="top_left_h4">Builders/ Builders List/ View</h4>
        </div>
      </div>

      <div className="details_table_left">
        <div className="flex-container flex-justify-between gap-10 ">
          <img
            style={{ borderRadius: "25px", width: "120px", height: "120px" }}
            src={
              builderData?.profile_image
                ? builderData.profile_image
                : require("./Icons/AlternateImage.png")
            }
            alt="Profile"
          />
          <Link to={`/builders/${id}/review`}>
            <button className="button-class-white">Add Review</button>
          </Link>
        </div>
        <div className="margin-h-10">
          <span className="span-builder">Builder Id</span>
          <h4 className="margin-0">{builderData?.builder_id || "No Data"}</h4>
        </div>
        <div className="flex-container gap-10 align-center margin-h-10">
          <img src={icons["Organization"]} alt="" />
          <div>
            <span className="span-builder">Organization Name</span>
            <h4 className="margin-0">{builderData?.organization_name}</h4>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <SelectInput
            placeholder="Select an Option"
            onChange={handleStatusChange}
            value={selectedStatus.status}
            label="Select Builder Status"
            name="builder_id"
            options={Object.entries(accountStatusData).map(([_, value]) => ({
              label: value.charAt(0).toUpperCase() + value.slice(1),
              value: value,
            }))}
          ></SelectInput>
        </div>
        <div className="builder_account_status">
          <img src={icons["Status"]} alt="" />
          <div>
            <span className="span-builder">Builder Status</span>
            <h4 className="margin-0">
              {ToFirstCapital(builderData?.account_status)}
            </h4>
          </div>
        </div>
        <div className="line_container">
          <span>Primary Contact detail</span>
          <hr />
        </div>
        <div className="flex-container gap-10 align-center margin-h-10">
          <img src={icons["Name"]} alt="" />
          <div>
            <span className="span-builder">Name</span>
            <h4 className="margin-0">{builderData?.brand_name || "No Data"}</h4>
          </div>
        </div>
        <div className="flex-container gap-10 align-center margin-h-10">
          <img src={icons["Email"]} alt="" />
          <div>
            <span className="span-builder">Email</span>
            <h4 className="margin-0">
              {builderData?.primary_email || "No Data"}
            </h4>
          </div>
        </div>
        <div className="flex-container gap-10 align-center margin-h-10">
          <img src={icons["Phone Number"]} alt="" />
          <div>
            <span className="span-builder">Phone Number</span>
            <h4 className="margin-0">
              {builderData?.primary_contact_number || "No Data"}
            </h4>
          </div>
        </div>
        <div className="flex-container gap-10 align-center margin-h-10">
          <img src={icons["ID"]} alt="" />
          <div>
            <span className="span-builder">RERA Id</span>
            <h4 className="margin-0">{builderData?.rera_id}</h4>
          </div>
        </div>
        <div className="flex-container gap-10 align-center margin-h-10">
          <img src={icons["Address"]} alt="" />
          <div>
            <span className="span-builder">Address</span>
            <h4 className="margin-0">{builderData?.address || "No Data"}</h4>
          </div>
        </div>
        <div className="line_container">
          <span>Secondary Contact detail</span>
          <hr />
        </div>
        <div className="flex-container gap-10 align-center margin-h-10">
          <img src={icons["Email"]} alt="" />
          <div>
            <span className="span-builder">Secondary Email</span>
            <h4 className="margin-0">
              {builderData?.secondary_email || "No Data"}
            </h4>
          </div>
        </div>
        <div className="flex-container gap-10 align-center margin-h-10">
          <img src={icons["Phone Number"]} alt="" />
          <div>
            <span className="span-builder">Secondary Phone Number</span>
            <h4 className="margin-0">
              {builderData?.secondary_contact_number || "No Data"}
            </h4>
          </div>
        </div>
        <SelectInput
          placeholder="Select Assigned Person"
          required
          label=""
          value={""}
          onChange={handlePersonAssign}
          name="assiged_person"
          options={staffOptions}
        ></SelectInput>
        {memberAssigend && (
          <>
            <div className="line_container">
              <span>Authorised Person detail</span>
              <hr />
            </div>

            {memberAssigend?.map((person) => (
              <div key={person._id} className="authorized-person-block">
                <div className="flex-container gap-10 align-center margin-h-10">
                  <img src={icons["Name"]} alt="Name icon" />
                  <div>
                    <span className="span-builder">Name</span>
                    <h4 className="margin-0">{person.name || "No Data"}</h4>
                  </div>
                </div>

                <div className="flex-container gap-10 align-center margin-h-10">
                  <img src={icons["Email"]} alt="Email icon" />
                  <div>
                    <span className="span-builder">Email</span>
                    <h4 className="margin-0">{person.email || "No Data"}</h4>
                  </div>
                </div>

                <div className="flex-container gap-10 align-center margin-h-10">
                  <img src={icons["Phone Number"]} alt="Phone icon" />
                  <div>
                    <span className="span-builder">Phone Number</span>
                    <h4 className="margin-0">
                      {person.contact_number || "No Data"}
                    </h4>
                  </div>
                </div>

                <div className="flex-container gap-10 align-center margin-h-10">
                  <img src={icons["ID"]} alt="ID icon" />
                  <div>
                    <span className="span-builder">Company ID</span>
                    {/* I’m assuming “company_id” is the staff_id field in your data */}
                    <h4 className="margin-0">{person.staff_id || "No Data"}</h4>
                  </div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
      <div className="details_table_right margin-w-10">
        <div className="bg-white border-10 padding-10 ">
          <div className="hover_panel">
            <h4
              className={selectedTable === "projects" ? "clicked" : ""}
              onClick={() => handleTableSelection("projects")}
            >
              Projects
            </h4>
            <h4
              onClick={() => handleTableSelection("properties")}
              className={selectedTable === "properties" ? "clicked" : ""}
            >
              Properties
            </h4>
            {/* <h4
              onClick={() => handleTableSelection("events")}
              className={selectedTable === "events" ? "clicked" : ""}
            >
              Events
            </h4> */}
            <h4
              onClick={() => handleTableSelection("bookings")}
              className={selectedTable === "bookings" ? "clicked" : ""}
            >
              Bookings
            </h4>
            <h4
              onClick={() => handleTableSelection("deals")}
              className={selectedTable === "deals" ? "clicked" : ""}
            >
              Deals
            </h4>
            <h4 className={selectedTable === "ratings" ? "clicked" : ""}>
              Ratings
            </h4>
          </div>
        </div>
        {selectedTable === "projects" && (
          <Table
            dataSource={Array.isArray(projects?.data) ? projects.data : []}
            columns={Array.isArray(columnsProjects) ? columnsProjects : []}
          />
        )}
        {selectedTable === "properties" && (
          <Table
            columns={columnsProperties}
            dataSource={Array.isArray(properties?.data) ? properties.data : []}
          ></Table>
        )}
        {selectedTable === "events" && (
          <Table
            dataSource={Array.isArray(events?.data) ? events.data : []}
            columns={columnsEvents}
          ></Table>
        )}
        {selectedTable === "bookings" && (
          <Table
            dataSource={
              Array.isArray(bookings?.data?.result) ? bookings.data.result : []
            }
            columns={columnsBookings}
          ></Table>
        )}
        {selectedTable === "deals" && (
          <Table
            dataSource={Array.isArray(deals?.data) ? deals.data : []}
            columns={columnsDeals}
          ></Table>
        )}
      </div>
    </div>
  );
};

export default ViewBuilder;
